(function () {
  'use strict';

  var LABELS = {
    tr: {
      soldout: 'Tükendi',
      low: 'Düşük Stok',
      available: 'Stokta var',
      critical: function (n) { return 'Son ' + n + ' ürün'; }
    },
    en: {
      soldout: 'Sold Out',
      low: 'Low Stock',
      available: 'Available',
      critical: function (n) { return 'Last ' + n + ' items'; }
    }
  };

  function setup(root) {
    var target = root.querySelector('[data-gnd-stock-status]');
    if (!target) return;

    var sectionId = root.dataset.sectionId;
    var locale = root.dataset.locale === 'tr' ? 'tr' : 'en';
    var L = LABELS[locale];

    var dataEl = document.querySelector('#product-' + sectionId + ' [data-js-variant-quantity-data]');
    var inventory = [];
    if (dataEl) {
      try { inventory = JSON.parse(dataEl.dataset.inventory) || []; } catch (e) { inventory = []; }
    }

    var productVariants = document.querySelector('product-variants[data-id="' + sectionId + '"]');
    if (!productVariants) return;

    function clear() {
      target.removeAttribute('data-stock-tier');
      target.className = 'gnd-stock-status';
      target.textContent = '';
    }

    function paint(tier, label) {
      target.dataset.stockTier = tier;
      target.className = 'gnd-stock-status gnd-stock-status--' + tier;
      target.textContent = label;
    }

    function update() {
      var cv = productVariants.currentVariant;
      if (!cv) { clear(); return; }

      var data = null;
      for (var i = 0; i < inventory.length; i++) {
        if (inventory[i].id === cv.id) { data = inventory[i]; break; }
      }
      if (!data || typeof data.quantity === 'undefined') { clear(); return; }

      var qty = parseInt(data.quantity, 10);
      if (isNaN(qty)) { clear(); return; }

      if (qty <= 0) {
        if (data.inventory === 'continue') { clear(); return; }
        paint('soldout', L.soldout);
      } else if (qty <= 5) {
        paint('critical', L.critical(qty));
      } else if (qty <= 10) {
        paint('low', L.low);
      } else {
        paint('available', L.available);
      }
    }

    productVariants.addEventListener('VARIANT_CHANGE', update);
  }

  function init() {
    document.querySelectorAll('[data-gnd-stock-status-root]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
